<template>
  <div>
    <div>
      <RoomBookingDialog ref="roomBookingDialog" />

      <ul class="rooms-list">
        <li
          class="rooms-list-item row scroll-horizontal-bar"
          v-for="room in sortedRooms"
          :key="room.id"
          style="overflow: hidden"
        >
          <div>
            <div class="pic-side col btn">
              <img
                src="../../../../../../../src/assets/images/image-24.png"
                alt="image d'une salle"
                style="border-radius: 50px"
              />
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <button v-on="on" style="align-items: start">
                    <sub-icon :resource="room" />
                  </button>
                </template>
                <span v-if="isNotSubscribed(room)">
                  {{ $t("crudRooms.subscribeToThisRoom") }}
                </span>
                <span v-else>
                  {{ $t("crudRooms.unsubscribeToThisRoom") }}
                </span>
              </v-tooltip>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-around;
                align-items: bas;
              "
            >
              <p>{{ room.name }}</p>
            </div>
          </div>
          <div class="timeslot-side col">
            <div class="head-item row">
              <ul class="icons-list">
                <li class="btn neumorphism-out btn-room">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <button v-on="on" class="center-content">
                        <v-icon>{{ pathDesk }}</v-icon>
                        {{ room.fullCapacity }}
                      </button>
                    </template>
                    <span class="center-content">{{
                      $t("crudCommon.tooltipFullCapacity")
                    }}</span>
                  </v-tooltip>
                </li>
                <li class="btn neumorphism-out">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <button
                        @click="($event) => goToDetails(room.centerId,room.id)"
                        v-on="on"
                      >
                        <span class="center-content">{{
                          $t("crudCommon.tooltipDetails")
                        }}</span>
                      </button>
                    </template>
                    <span>{{ $t("crudRooms.details") }}</span>
                  </v-tooltip>
                </li>
              </ul>
              <button class="book-btn" @click="openBookingDialog(room)">
                {{ $t("crudCommon.book") }}
              </button>
            </div>
            <div class="timeslot row">
              <TimeGrid v-if="room && bookingsFetched" :room="room" />
              <v-progress-circular v-else indeterminate color="red darken-1" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  mdiStarOutline,
  mdiStar,
  mdiAccountMultiple,
  mdiMonitor,
  mdiDesk,
} from "@mdi/js";
import TimeGrid from "@/components/components-salles/public/room/list/subcomponent/timegrid/RoomsTimeGrid.vue";
import RoomBookingDialog from "@/components/components-salles/public/booking/RoomBookingDialog";
import { mapGetters, mapActions } from "vuex";
import SubIcon from "../../../../admin/details/room/SubIcon.vue";

export default {
  name: "rooms-list",
  components: {
    TimeGrid,
    RoomBookingDialog,
    SubIcon,
  },
  props: ["rooms"],
  data() {
    return {
      pathStarOutline: mdiStarOutline,
      path: mdiStarOutline,
      pathStar: mdiStar,
      pathEmployees: mdiAccountMultiple,
      pathMaterials: mdiMonitor,
      pathDesk: mdiDesk,
      subscribe: false,
    };
  },
  computed: {
    ...mapGetters("centerModule", { centers: "getCenters" }),
    ...mapGetters("roomModule", {
      getRooms: "getRooms",
      roomById: "getRoomById",
    }),
    ...mapGetters("bookingModule", {
      bookingsFetched: "wasBookingsFetched",
    }),
    ...mapGetters("userModule", ["getCurrentUser"]),
    sortedRooms() {
      let sortedSlots = this.rooms.filter((x) => x.available == true);
      sortedSlots = sortedSlots.sort((a, b) => {
        let A = a.name,
          B = b.name;
        if (A < B) {
          return -1;
        }
        if (A > B) {
          return 1;
        }
        return 0;
      });
      return sortedSlots.sort();
    },
    room() {
      return this.roomById(parseInt(this.$route.params.roomId));
    },
  },
  methods: {
    ...mapActions("roomModule", ["editRoom"]),

    goToDetails(centerId, roomId) {
      this.$router
        .push({
          name: "room-details-with-desk-slot",
          params: {
            centerId: centerId,
            roomId: roomId,
          },
        })
        .catch(() => {});
    },
    onClickStar(event) {
      event.path = mdiStar;
    },
    openBookingDialog(room) {
      this.$refs.roomBookingDialog.open(room);
    },
    isNotSubscribed(item) {
      return !item.subscribersIds.includes(this.getCurrentUser);
    },
  },
};
</script>

<style>
.center-content {
  display: flex;
  align-items: center;
}
.scroll-vertical-bar {
  height: fit-content;
  max-height: 700px;
  overflow: scroll;
  margin: 2px;
}
.scroll-horizontal-bar {
  overflow: scroll;
  margin: 5px;
  white-space: nowrap;
}
.rooms-list {
  display: flexbox;
}
.rooms-list-item {
  font-size: 1rem;
  text-transform: uppercase;
  background: #f8f8f8;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  margin-right: 0.5rem;
  display: flex;
  flex-wrap: nowrap;
}
.book-btn {
  background-color: #e53935;
  padding: 10px 35px;
  color: #f8f8f8;
  border-radius: 4px;
  text-transform: uppercase;
  margin-right: 1rem;
  display: flex;
}
.head-item {
  margin: 1px;
  justify-content: space-between;
}
.pic-side {
  flex: 1;
  display: flex;
  align-items: start;
}
.timeslot-side {
  flex: 5;
}
.timeslot {
  padding-top: 1rem;
}
.icons-list {
  display: inline-flex;
  align-items: center;
}
.btn-room {
  margin-right: 10px;
}
.scroll-vertical-bar2 {
  height: 300px;
  max-height: 300px;
  overflow: scroll;
}
</style>
